<p-toast></p-toast>
<p-confirmDialog
  [breakpoints]="{'960px': '75vw', '640px': '90vw'}"
  [style]="{width: '40vw'}"
  acceptLabel="Sí"
  rejectLabel="Cancelar"
  acceptButtonStyleClass="p-button border-round-3xl"
  rejectButtonStyleClass="p-button-danger border-round-3xl">
</p-confirmDialog>

<div class="w-full bg-white p-3 md:p-5">
  <div class="flex flex-column md:flex-row justify-content-between align-items-center gap-3 mb-5">
    <div class="flex align-items-center gap-3 w-full md:w-auto">
      <div class="hidden md:block">
        <h2 class="m-0 font-bold" style="font-family: 'Prata', serif;">Usuarios admin</h2>
        <p class="m-0 mt-1 text-xs text-500">Solo personal con acceso al panel. Los clientes web están en Sistema → Clientes.</p>
      </div>
      <span class="p-input-icon-left w-full md:w-auto">
        <i style="padding-right: 10px"></i>
        <input pInputText type="text" [(ngModel)]="filters.searchTerms"
               (keyup)="onSearch()"
               placeholder="Buscar admin..."
               class="w-full md:w-25rem border-round-3xl" />
      </span>
    </div>

    <div class="flex flex-wrap gap-2 w-full md:w-auto justify-content-end">
      <button pButton icon="pi pi-filter-slash"
              class="p-button-outlined p-button-secondary border-round-3xl"
              (click)="clearFilters()" pTooltip="Limpiar filtros"></button>

      <button pButton label="Nuevo admin" icon="pi pi-plus"
              class="p-button-black border-round-3xl px-4"
              (click)="openCreateModal()"></button>
    </div>
  </div>

  <p-table [value]="users" [lazy]="true" (onLazyLoad)="loadUsers($event)"
           [paginator]="true" [rows]="rows" [totalRecords]="totalRecords"
           [loading]="loading" [rowHover]="true"
           class="p-datatable-sm">
    <ng-template pTemplate="header">
      <tr class="uppercase text-xs text-500">
        <th style="width: 5rem">ID</th>
        <th>Nombre Completo</th>
        <th>Usuario</th>
        <th>Email</th>
        <th class="text-center">Rol</th>
        <th class="text-center">Estado</th>
        <th class="text-center" style="width: 120px">Acciones</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-user>
      <tr class="text-sm border-bottom-1 surface-border">
        <td class="text-500">#{{user.idUser}}</td>
        <td class="font-bold text-900">{{ user.fullname}}</td>
        <td>{{ user.username }}</td>
        <td>{{ user.email }}</td>
        <td class="text-center">
          <p-tag [value]="user.roleName.replace('ROLE_', '')"
                 [severity]="user.roleName === 'ROLE_ADMIN' ? 'warn' : 'info'"
                 styleClass="text-xs border-round-3xl px-3 font-bold">
          </p-tag>
        </td>
        <td class="text-center">
          <i class="pi" [ngClass]="user.isActive ? 'pi-check-circle text-green-500' : 'pi-times-circle text-red-500'"
             style="font-size: 1.3rem;"></i>
        </td>
        <td class="text-center">
          <div class="flex justify-content-center gap-2">
            <button pButton icon="pi pi-pencil"
                    class="p-button-text p-button-rounded text-600 hover:text-900"
                    (click)="editUser(user)"></button>
            <button pButton [icon]="user.isActive ? 'pi pi-power-off' : 'pi pi-refresh'"
                    class="p-button-text p-button-rounded"
                    [ngClass]="user.isActive ? 'text-red-400 hover:text-red-600' : 'text-green-400 hover:text-green-600'"
                    (click)="toggleStatus(user)"></button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog header="Nuevo administrador" [(visible)]="displayCreateModal" [modal]="true"
          class="p-fluid" [style]="{ width: '500px' }" [draggable]="false">
  <ng-template pTemplate="content">
    <div class="formgrid grid pt-3">
      <div class="field col-12">
        <label>Nombre Completo</label>
        <input pInputText [(ngModel)]="newUser.fullname"  class="border-round-lg" />
      </div>
      <div class="field col-12">
        <label>Email</label>
        <input pInputText type="email" [(ngModel)]="newUser.email" placeholder="correo@ejemplo.com" class="border-round-lg" />
      </div>
      <div class="field col-12">
        <small class="text-600">Se creará con rol <strong>ADMIN</strong> (acceso al panel). No aparece en Clientes.</small>
      </div>
      <div class="field col-6">
        <label>Username</label>
        <input pInputText [(ngModel)]="newUser.username" class="border-round-lg" />
      </div>
      <div class="field col-6">
        <label>Password</label>
        <input pInputText type="password" [(ngModel)]="newUser.password" class="border-round-lg" />
      </div>
      <div class="field col-6">
        <label>Fecha de Nacimiento</label>
        <input pInputText type="date" [(ngModel)]="newUser.birthDate" class="border-round-lg w-full" />
      </div>
      <div class="field col-6">
        <label>Teléfono</label>
        <input pInputText type="tel" [(ngModel)]="newUser.telephone" class="border-round-lg w-full" />
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <button pButton label="Cancelar" class="p-button-text text-900" (click)="displayCreateModal=false"></button>
      <button pButton label="Crear admin" icon="pi pi-check" class="p-button-black border-round-3xl px-4" (click)="saveNewUser()"></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog header="Editar Usuario" [(visible)]="displayEditModal" [modal]="true"
          styleClass="p-fluid" [style]="{ width: '450px' }" [draggable]="false">
  <ng-template pTemplate="content">
    <div class="flex flex-column gap-3 pt-3">
      <div class="field">
        <label>Nombre Completo</label>
        <input pInputText [(ngModel)]="selectedUser.fullname" class="border-round-lg" />
      </div>
      <div class="field">
        <label>Email</label>
        <input pInputText type="email" [(ngModel)]="selectedUser.email" class="border-round-lg" />
      </div>
      <div class="field">
        <label class="text-900 font-bold">Rol</label>
        <input pInputText [ngModel]="'ADMIN'" [readonly]="true" class="border-round-lg" />
        <small class="text-500">Los clientes web se gestionan en Sistema → Clientes.</small>
      </div>
      <div class="field bg-surface-50 p-3 border-round-lg">
        <label class="font-bold block mb-3">Estado de la cuenta</label>
        <div class="flex align-items-center gap-3">
          <p-toggleswitch [(ngModel)]="selectedUser.isActive"></p-toggleswitch>
          <span [class]="selectedUser.isActive ? 'text-green-600 font-bold' : 'text-red-600 font-bold'">
            {{ selectedUser.isActive ? 'ACTIVO' : 'INACTIVO' }}
          </span>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <button pButton label="Cancelar" class="p-button-text text-900" (click)="displayEditModal=false"></button>
      <button pButton label="Guardar Cambios" icon="pi pi-check" class="p-button-black border-round-3xl px-4" (click)="saveUser()"></button>
    </div>
  </ng-template>
</p-dialog>
